
// import React, { useEffect, useState } from 'react';
// import { Typography, Box, Paper, Grid } from '@mui/material';
// import { useParams } from 'react-router-dom';
// import { get } from '../../../../utils/api';

// interface RightSideProps {
//     module: string;
//     field_name: string;
//     key_name: string;
//     values: any[]; // Dictionary-like object for values
//     primary_key: string;
// }

// const RightSideCommonComponent: React.FC<RightSideProps> = ({
//     module,
//     field_name,
//     key_name,
//     values,
//     primary_key,
// }) => {
//     const { id } = useParams(); // Fetches the `id` from the route parameters
//     const [fields, setFields] = useState<Array<any>>([]);
//     const [displayValues, setDisplayValues] = useState<any[]>([]);

//     useEffect(() => {
//         getFields();
//     }, [key_name]);

//     const getFields = async () => {
//         try {
//             const response = await get(`${module}`, {});
//             setFields(response.data.fields);
//             const selected_key_data = response.data.fields.find((e: any) => e.key === field_name);

//             if (selected_key_data && selected_key_data.mapped_collection) {
//                 const selected_field_name = selected_key_data.mapped_collection.primary_name_field;
//                 const display_values = values.map((e) => e[selected_field_name]);
//                 setDisplayValues(display_values)
//                 console.log("displayed_values", display_values);
//             } else {
//                 console.log("No matching field found or mapped_collection missing for:", field_name);
//             }
//         } catch (error) {
//             console.log("Error fetching fields: ", error);
//         }
//     };


//     // Join all values into a single string
//     const combinedValues = values.join(', ');

//     return (
//         <Box sx={{ marginTop: 4, paddingLeft: 3, paddingRight: 3, paddingBottom: 6 }}>
//             <Typography
//                 variant="h4"
//                 sx={{
//                     marginBottom: 4,
//                     fontWeight: 500,
//                     color: '#333',
//                     fontSize: '1rem',
//                     letterSpacing: '0.5px',
//                     textTransform: 'capitalize',
//                 }}
//             >
//                 {`Details for ${key_name}`}
//             </Typography>

//             <Paper
//                 elevation={0}
//                 sx={{
//                     padding: 5,
//                     backgroundColor: '#f9fafc',
//                 }}
//             >
//                 <Grid container spacing={3} sx={{ marginBottom: 2 }}>
//                     <Grid item xs={12} md={3}>
//                         <Typography
//                             variant="subtitle2"
//                             sx={{
//                                 fontWeight: 500,
//                                 fontSize: '13px',
//                                 color: '#555',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                             }}
//                         >
//                             {key_name}
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={12} md={6}>

//                         {/* {displayValues.length>0 ( */}
//                             <Typography
//                                 variant="body1"
//                                 sx={{
//                                     fontSize: '13px',
//                                     fontWeight: 400,
//                                     backgroundColor: '#fff',
//                                     padding: '3px',
//                                     borderRadius: '1px',
//                                     border: '1px solid #e0e0e0',
//                                     maxHeight: '200px',
//                                     overflow: 'auto',
//                                     whiteSpace: 'pre-wrap',
//                                     wordBreak: 'break-word',
//                                 }}
//                             >
//                                 {displayValues }
//                             </Typography>

//                     </Grid>
//                 </Grid>
//             </Paper>
//         </Box>
//     );
// };

// export default RightSideCommonComponent;





// import React, { useEffect, useState } from 'react';
// import { Typography, Box, Paper, Grid, Checkbox, FormControlLabel } from '@mui/material';
// import { useParams } from 'react-router-dom';
// import { get } from '../../../../utils/api';

// interface RightSideProps {
//     module: string;
//     field_name: string;
//     key_name: string;
//     values: any[]; // Dictionary-like object for values
//     primary_key: string;
// }

// const RightSideCommonComponent: React.FC<RightSideProps> = ({
//     module,
//     field_name,
//     key_name,
//     values,
//     primary_key,
// }) => {
//     const { id } = useParams(); // Fetches the `id` from the route parameters
//     const [fields, setFields] = useState<Array<any>>([]);
//     const [displayValues, setDisplayValues] = useState<any[]>([]);
//     const [selectedValues, setSelectedValues] = useState<any[]>([]);

//     useEffect(() => {
//         getFields();
//     }, [key_name]);

//     const getFields = async () => {
//         try {
//             const response = await get(`${module}`, {});
//             setFields(response.data.fields);
//             const selected_key_data = response.data.fields.find((e: any) => e.key === field_name);

//             if (selected_key_data && selected_key_data.mapped_collection) {
//                 const selected_field_name = selected_key_data.mapped_collection.primary_name_field;
//                 const display_values = values.map((e) => e[selected_field_name]);
//                 setDisplayValues(display_values);
//                 setSelectedValues(display_values); // Initially, select all values
//                 console.log("displayed_values", display_values);
//             } else {
//                 console.log("No matching field found or mapped_collection missing for:", field_name);
//             }
//         } catch (error) {
//             console.log("Error fetching fields: ", error);
//         }
//     };

//     const handleCheckboxChange = (value: string) => {
//         setSelectedValues((prevSelectedValues) =>
//             prevSelectedValues.includes(value)
//                 ? prevSelectedValues.filter((v) => v !== value)
//                 : [...prevSelectedValues, value]
//         );
//     };

//     return (
//         <Box sx={{ marginTop: 4, paddingLeft: 3, paddingRight: 3, paddingBottom: 6 }}>
//             <Typography
//                 variant="h4"
//                 sx={{
//                     marginBottom: 4,
//                     fontWeight: 500,
//                     color: '#333',
//                     fontSize: '1rem',
//                     letterSpacing: '0.5px',
//                     textTransform: 'capitalize',
//                 }}
//             >
//                 {`Details for ${key_name}`}
//             </Typography>

//             <Paper
//                 elevation={0}
//                 sx={{
//                     padding: 5,
//                     backgroundColor: '#f9fafc',
//                 }}
//             >
//                 <Grid container spacing={3} sx={{ marginBottom: 2 }}>
//                     <Grid item xs={12} md={3}>
//                         <Typography
//                             variant="subtitle2"
//                             sx={{
//                                 fontWeight: 500,
//                                 fontSize: '13px',
//                                 color: '#555',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                             }}
//                         >
//                             {key_name}
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={12} md={6}> 
//                         {displayValues.length > 0 ? (
//                             <Box
//                                 sx={{
//                                     backgroundColor: '#fff',
//                                     padding: '3px',
//                                     borderRadius: '1px',
//                                     border: '1px solid #e0e0e0',
//                                     maxHeight: '800px',
//                                     overflow: 'auto',
//                                 }}
//                             >
//                                 {displayValues.map((value) => (
//                                     <>
//                                     <FormControlLabel
//                                         key={value}
//                                         control={
//                                             <Checkbox
//                                                 checked={selectedValues.includes(value)}
//                                                 onChange={() => handleCheckboxChange(value)}
//                                             />
//                                         }
//                                         label={value}
//                                         sx={{
//                                             fontSize: '13px',
//                                             fontWeight: 400,
//                                             color: '#333',
//                                         }}
//                                     />
//                                     <br></br>
//                                     </>
//                                 ))}
//                             </Box>
//                         ) : (
//                             <Typography variant="body1">N/A</Typography>
//                         )}
//                     </Grid>
//                 </Grid>
//             </Paper>
//         </Box>
//     );
// };

// export default RightSideCommonComponent;



import React, { useEffect, useState } from 'react';
import { Typography, Box, Paper, Grid, List, ListItem, ListItemText } from '@mui/material';
import { useParams } from 'react-router-dom';
import { get } from '../../../../utils/api';

interface RightSideProps {
    module: string;
    field_name: string;
    key_name: string;
    values: any[]; // Dictionary-like object for values
    primary_key: string;
}

const RightSideCommonComponent: React.FC<RightSideProps> = ({
    module,
    field_name,
    key_name,
    values,
    primary_key,
}) => {
    const { id } = useParams(); // Fetches the `id` from the route parameters
    const [fields, setFields] = useState<Array<any>>([]);
    const [displayValues, setDisplayValues] = useState<any[]>([]);

    useEffect(() => {
        getFields();
    }, [key_name]);

    const getFields = async () => {
        try {
            const response = await get(`${module}`, {});
            setFields(response.data.fields);
            const selected_key_data = response.data.fields.find((e: any) => e.key === field_name);

            if (selected_key_data && selected_key_data.mapped_collection) {
                const selected_field_name = selected_key_data.mapped_collection.primary_name_field;
                const display_values = values.map((e) => e[selected_field_name]);
                setDisplayValues(display_values);
                console.log("displayed_values", display_values);
            } else {
                console.log("No matching field found or mapped_collection missing for:", field_name);
            }
        } catch (error) {
            console.log("Error fetching fields: ", error);
        }
    };

    return (
        <Box sx={{ marginTop: 4, paddingLeft: 3, paddingRight: 3, paddingBottom: 6 }}>
            <Typography
                variant="h4"
                sx={{
                    marginBottom: 4,
                    fontWeight: 500,
                    color: '#333',
                    fontSize: '1rem',
                    letterSpacing: '0.5px',
                    textTransform: 'capitalize',
                }}
            >
                {`Details for ${key_name}`}
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    padding: 5,
                    backgroundColor: '#f9fafc',
                }}
            >
                <Grid container spacing={3} sx={{ marginBottom: 2 }}>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 500,
                                fontSize: '13px',
                                color: '#555',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {key_name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {displayValues.length > 0 ? (
                            <List
                                sx={{
                                    backgroundColor: '#fff',
                                    padding: '3px',
                                    borderRadius: '1px',
                                    border: '1px solid #e0e0e0',
                                    maxHeight: '800px',
                                    overflow: 'auto',
                                }}
                            >
                                {displayValues.map((value) => (
                                    <ListItem key={value} sx={{ padding: '0', display: 'flex', alignItems: 'center' }}>
                                        <Box
                                            sx={{
                                                width: '5px',
                                                height: '5px',
                                                backgroundColor: '#333',
                                                borderRadius: '50%',
                                                marginRight: '8px',
                                            }}
                                        />
                                        <ListItemText
                                            primary={value}
                                            primaryTypographyProps={{
                                                fontSize: '13px',
                                                fontWeight: 400,
                                                color: '#333',
                                            }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        ) : (
                            <Typography variant="body1">N/A</Typography>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
};

export default RightSideCommonComponent;
